import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { CategoryComponent } from './category/category.component';
import { QAndAComponent } from './q-and-a/q-and-a.component';
import { MoreTopicsComponent } from './shared/more-topics/more-topics.component';
import { PatientHelpCenterModule } from '../../store/src/lib/patient-help-center.module';
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    CategoryComponent,
    QAndAComponent,
    MoreTopicsComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbModule,
    PatientHelpCenterModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
